import { useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, X } from "lucide-react";
import { HELPER_LATEST_VERSION, helperVersion, isHelperOutdated } from "@/lib/helper";

const KEY = "pp_helper_update_dismissed";

export default function HelperUpdateBanner() {
  const [hidden, setHidden] = useState(() => localStorage.getItem(KEY) === HELPER_LATEST_VERSION);
  if (hidden || !isHelperOutdated()) return null;
  const dismiss = () => { localStorage.setItem(KEY, HELPER_LATEST_VERSION); setHidden(true); };
  return (
    <div className="fade-up mb-6 flex items-center justify-between gap-3 rounded-xl border border-amber-500/30 bg-amber-500/10 px-5 py-3 text-sm text-amber-200" data-testid="dash-helper-update-banner">
      <span className="flex items-start gap-2">
        <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
        <span>PostPintar Helper anda <b className="font-mono">v{helperVersion()}</b> sudah lama. Versi baharu <b className="font-mono">v{HELPER_LATEST_VERSION}</b> tersedia.</span>
      </span>
      <span className="flex shrink-0 items-center gap-3">
        <Link to="/tetapan" className="font-semibold hover:underline" data-testid="dash-helper-update-link">Kemas kini →</Link>
        <button type="button" onClick={dismiss} aria-label="Tutup" className="text-amber-200/70 transition-colors hover:text-amber-100" data-testid="dash-helper-update-dismiss"><X className="h-4 w-4" /></button>
      </span>
    </div>
  );
}
